import {AuditService} from "../PA.Core/Security/AuditService";
import {
    WB_FinishedProductRelationshipRow,
    WB_ProductGroupAttributeRow,
    WB_ProductGroupRelationshipRow, WB_ProductGroupSalesAreaRow
} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";
import {ProductGroupBO} from "./ProductGroupBO";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {
    esWB_Finished_Product,
    esWB_Product_Attribute_Group,
    esWB_Product_Group,
    esWB_Product_Hierarchy, esWB_SalesArea
} from "../PA.Core/PAdbSchema";

export class ProductGroupBOAudit {

    // Audit Log Service for Product

    static async ProductGroupAuditBO(ProductGroupBO: ProductGroupBO): Promise<AuditService> {
        const self = ProductGroupBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("ProductGroup", self.drWB_ProductGroup.cif.WB_PRDGRP_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Adding new Product Group on screen
        const productGroupParams: IAuditField [] = [
            {fieldName: "PRODUCT_GROUP_NAME", realName: "Name", bAllMsg: true},
            {fieldName: "PRODUCT_GROUP_ID", realName: "ID"},
            {fieldName: "STATUS_CODE", realName: "Status"},
            {fieldName: "BASE_UOM", realName: "Base UOM"},

        ]

        // Children Product
        const productGroupChildProductParams: IAuditField [] = [
            {
                fieldName: "WB_PROD_ID",
                realName: `Child Product`,
                fkMapper: esWB_Finished_Product,
                fkMapperNameField: "PRODUCT_NAME",
                fkMapperIdField: "PRODUCT_ID",
                bAllMsg: true
            },
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
            {
                fieldName: "WB_PRDH_ID",
                realName: "Hierarchy",
                fkMapper: esWB_Product_Hierarchy,
                fkMapperNameField: "HIERARCHY_ID",
                fkMapperIdField: "WB_PRDH_ID"
            },
        ]
        // Children product group

        const productGroupChildRelParams: IAuditField [] = [
            {
                fieldName: "WB_PRDGRP_ID",
                realName: `Name`,
                fkMapper: esWB_Product_Group,
                fkMapperNameField: "PRODUCT_GROUP_NAME",
                fkMapperIdField: "PRODUCT_GROUP_ID",
                bAllMsg: true
            },
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
            {
                fieldName: "WB_PRDH_ID",
                realName: "Hierarchy",
                fkMapper: esWB_Product_Hierarchy,
                fkMapperNameField: "HIERARCHY_ID",
                fkMapperIdField: "WB_PRDH_ID"
            },
        ]
        // parent
        const productGroupRelParams: IAuditField [] = [
            {
                fieldName: "WB_PRDGRP_ID_PRNT",
                realName: `Product Group Name`,
                fkMapper: esWB_Product_Group,
                fkMapperNameField: "PRODUCT_GROUP_NAME",
                fkMapperIdField: "PRODUCT_GROUP_ID",
                bAllMsg: true
            },
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
            {
                fieldName: "WB_PRDH_ID",
                realName: "Hierarchy",
                fkMapper: esWB_Product_Hierarchy,
                fkMapperNameField: "HIERARCHY_ID",
                fkMapperIdField: "WB_PRDH_ID"
            },
        ]

        // Consumer Attributes
        const consumerAttributeParams: IAuditField [] = [
            {
                fieldName: "WB_PRDGRP_ID",
                realName: `External Attributes, `,
                fkMapper: esWB_Product_Group,
                fkMapperNameField: "PRODUCT_GROUP_NAME",
                fkMapperIdField: "PRODUCT_GROUP_ID",
                bAllMsg: true
            },
            {fieldName: "GROUP_SET_ID", realName: "Product Group Set"},
            {fieldName: "REL_TYPE_ID", realName: "Type"},
            {fieldName: "ATTRIBUTE_ID", realName: "Value"},
            {fieldName: "ATTRIBUTE_VALUE", realName: "Value"},
            {fieldName: "EXCLUDE_IND", realName: "Excl"},
            {fieldName: "CNSPRDDIM_NAME_FIELDNAME", realName: "Name FieldName"},
            {fieldName: "CNSPRDDIM_ID_FIELDNAME", realName: "Id FieldName"},
            {fieldName: "CNSPRDDIM_IND", realName: "Populate Cns Attribute"},
            {fieldName: "CNSPRDDIM_PRDEQVPOLICY", realName: "Equiv Policy"},
            {fieldName: "CNSPRDDIM_EQVSTDSIZE", realName: "Equiv Standard Size"},
            {fieldName: "CNSPRDDIM_PRDGENPOLICY", realName: "Gen Policy"},
            {
                fieldName: "WB_PRDATTRGRP_ID",
                realName: "Value",
                fkMapper: esWB_Product_Attribute_Group,
                fkMapperNameField: "ATRGRP_NAME",
                fkMapperIdField: "WB_PRDATRG_ID"
            },
            {
                fieldName: "CNSPRDDIM_WB_PRDH_ID",
                realName: "Hierarchy ID",
                fkMapper: esWB_Product_Hierarchy,
                fkMapperNameField: "HIERARCHY_ID",
                fkMapperIdField: "WB_PRDH_ID"
            },
        ]

        // Sales Area
        const pgSalesArea: IAuditField[]= [
            {fieldName: "WB_SALESAREA_ID",
                fkMapper: esWB_SalesArea,
                fkMapperNameField: "SALESAREA_NAME",
                fkMapperIdField: "SALESAREA_ID",
                bAllMsg: true,
                realName: "Sales Area", },
        ]

            await AuditUtils.logRecord(auditService, self.drWB_ProductGroup, productGroupParams,{objectName: 'Product Group', deletedKeys: deleteKeys})
            // Children Product
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupChildProductRows, async (aPrdGrpChildPrdRow: WB_FinishedProductRelationshipRow) => {
                await AuditUtils.logRecord(auditService, aPrdGrpChildPrdRow, productGroupChildProductParams, {objectName: 'Child Product', deletedKeys: deleteKeys})
            })

            // Children product group
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children, async (aPrdGrpChildRelRow: WB_ProductGroupRelationshipRow) => {
                await AuditUtils.logRecord(auditService, aPrdGrpChildRelRow, productGroupChildRelParams, {objectName: 'Child Product Groups', deletedKeys: deleteKeys})
            })

            // parent
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, async (aPrdGrpPrntRelRow: WB_ProductGroupRelationshipRow) => {
                await AuditUtils.logRecord(auditService, aPrdGrpPrntRelRow, productGroupRelParams, {objectName: 'Parent', deletedKeys: deleteKeys})
            })

            // Consumer Attributes
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupExternalRelationshipRows, async (aPrdGrpPrntRelRow: WB_ProductGroupAttributeRow) => {
                await AuditUtils.logRecord(auditService, aPrdGrpPrntRelRow, consumerAttributeParams, {objectName: 'Consumer Attributes', deletedKeys: deleteKeys})
            })

        // Sales Area
        _.forEach(self.drWB_ProductGroup.WB_ProductGroupSalesAreaRows, async (aPrdGrpSalesAreaRow: WB_ProductGroupSalesAreaRow) => {
            await AuditUtils.logRecord(auditService, aPrdGrpSalesAreaRow, pgSalesArea, {objectName: 'Sales Area', deletedKeys: deleteKeys})
        })
            return auditService
    }

}